import * as React from "react"
const MoveIcon = (props) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={16}
        height={16}
        fill="none"
        {...props}
    >
        <path
            fill="#fff"
            d="m8 16-3.5-3.5 1.063-1.063 1.687 1.688V8.75H2.875l1.688 1.688L3.5 11.5 0 8l3.5-3.5 1.063 1.063L2.875 7.25H7.25V2.875L5.562 4.563 4.5 3.5 8 0l3.5 3.5-1.063 1.063L8.75 2.875V7.25h4.375l-1.688-1.688L12.5 4.5 16 8l-3.5 3.5-1.063-1.063 1.688-1.687H8.75v4.375l1.688-1.688L11.5 12.5 8 16Z"
        />
    </svg>
)
export default MoveIcon
